<div id="services">
  <div class="row justify-content-between services-header">
    <div class="col-12 col-lg-8 service-menus">
      @for (menu of menus; track menu) {
        <a class="menu" (click)="navigateToMenu(menu.route)" [class.active]="isRouteActivated(menu.route)">
          {{ menu.label | translate }}
        </a>
      }
    </div>
    <div class="col-12 col-lg-4 plantation-land mt-3 mt-lg-0">
      @if (selectedPlantation) {
        <div class="box" (click)="showSelectPlantationPanel()" [class.pointer]="!isCSIDomain">
          <div class="description">
            <i class="ph-fill ph-map-pin"></i>
            @if (selectedPlantation) {
              <span class="select-land-plantation">{{ selectedPlantation?.name }},</span>
              <span class="select-land-plantation">{{ selectedPlantation?.crop?.value }},</span>
              <span class="select-land-plantation">{{ selectedPlantation?.totalAreaDisplay }}</span>
            }
          </div>
        </div>
      }
    </div>
  </div>
  <div class="mt-3">
    @if (selectedPlantation) {
      <router-outlet />
    } @else if ((plantationService.loading$ | async) === true || csiPlantationLoading) {
      <div class="no-plantation-container row">
        <div class="col-12 text-center">
          <i class="pi pi-spin pi-spinner-dotted"></i>
        </div>
      </div>
    } @else if (routePlantationNotFound) {
      <div class="no-plantation-container row">
        <div class="col-12 col-md-6 col-lg-4 text-center">
          <p class="title">Plantation unavailable</p>
          <p class="content">The plantation in this link may not exist, may have been removed, or you may not have access to it.</p>

          <dk-button
            id="select-plantation-btn"
            [label]="'doktar_app.common.select_plantation_label'"
            severity="primary"
            (click)="showSelectPlantationPanel()" />
        </div>
      </div>
    } @else {
      <div class="no-plantation-container row">
        <div class="col-12 col-md-6 col-lg-4 text-center">
          <p class="title">{{ 'doktar_app.services.no_plantations_title' | translate }}</p>
          <p class="content">{{ 'doktar_app.services.no_plantations_description' | translate }}</p>

          <p class="legend">
            <i class="ph-fill ph-info"></i>
            <a (click)="dialogVisible = true">
              {{ 'doktar_app.services.no_plantations_legend_question' | translate }}
            </a>
          </p>

          <dk-button
            id="add-crop-btn"
            [label]="'doktar_app.land_plantations.plantation_list.add_crop'"
            severity="primary"
            [routerLink]="'/lands'" />
        </div>
      </div>
    }
  </div>
</div>

<p-dialog [(visible)]="dialogVisible" [modal]="true" [style]="{ width: '25rem' }">
  <ng-template #header>
    <span class="dialog-header">{{ 'doktar_app.services.no_plantations_legend_title' | translate }}</span>
  </ng-template>

  <img src="assets/svg/land-plantation.svg" alt="" />

  <p class="title mt-2">1. {{ 'doktar_app.services.land' | translate }}</p>
  <p class="content">
    {{ 'doktar_app.services.land_definition' | translate }}
  </p>
  <p class="title">2. {{ 'doktar_app.services.plantation' | translate }}</p>
  <p class="content">
    {{ 'doktar_app.services.plantation_definition' | translate }}
  </p>
</p-dialog>
